export function customTabsBlock() {
    $(".custom-tabs-nav button").on("click", function (e) {
        e.preventDefault();
        let $this = $(this);
        let $parent = $this.parents(".custom-tabs-block");
        const $customTabsNav = $parent.find(".custom-tabs-nav button");
        const $customTabsInfo = $parent.find(".custom-tabs-info-list .item");
        let index = $this.parent().index();
        if (!$this.hasClass("active")) {
            $customTabsNav.removeClass("active");
            $customTabsInfo.removeClass("active");
            $this.addClass("active");
            $customTabsInfo.eq(index).addClass("active");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customTabsBlock.js